import React from 'react';
import Plx from 'react-plx';

import Section from 'components/Section';


const PARALLAX_IMAGE = [
    {
        start: 'self',
        duration: 500,
        easing: 'linear',
        properties: [
            {
                startValue: 0,
                endValue: 400,
                unit: 'px',
                property: 'translateY',
            },
        ],
    },
];


const PARALLAX_CONTENT = [
    {
        start: 'self',
        duration: 500,
        easing: 'linear',
        properties: [
            {
                startValue: 0,
                endValue: 250,
                unit: 'px',
                property: 'translateY',
            },
        ],
    },
];


const CONTAINER_STYLE = {
    position: 'relative',
    overflow: 'hidden',
};

const LAYER_STYLE = {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
};


function NewPageCoverSection({children, style, image, ...props}) {
    return <Section
               slantBottom="up"
               theme="dark"
               style={{height: '800px', maxHeight: '100vh', ...CONTAINER_STYLE}}>

        <div style={LAYER_STYLE}>
            <CoverPhoto image={image} style={{height: '800px'}} />
        </div>

        <div style={LAYER_STYLE}>
            <div style={{
                ...LAYER_STYLE,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
            }}>
                <div style={{
                    // Compensate for the top navbar height
                    marginTop: '100px',
                }}>

                    <div>{children}</div>
                </div>
            </div>
        </div>

    </Section>;
}


function CoverPhoto({image, style, ...props}) {
    props.style = {
        background:`url(${image})`,
        backgroundSize: 'cover',
        // backgroundSize: 'auto',
        backgroundPosition: 'center top',
        height: '800px',
        ...style,
    };
    return <div {...props} />;
}


export default NewPageCoverSection;



// WEBPACK FOOTER //
// ./src/components/page-cover.js